const { SITE_BASE_URL, buildAbsoluteSiteUrl } = require('./brokerConnectionSource');

function absoluteUrl(value, baseUrl = SITE_BASE_URL) {
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  return buildAbsoluteSiteUrl(value, baseUrl);
}

function breadcrumbName(pathname, title) {
  if (pathname === '/') return 'Home';
  if (title) return title.replace(/\s+\|\s+BotSpot.*$/i, '');
  return pathname.split('/').filter(Boolean).pop().replace(/-/g, ' ');
}

function buildBreadcrumbs(route, baseUrl = SITE_BASE_URL) {
  const parts = route.path.split('/').filter(Boolean);
  const items = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: baseUrl,
    },
  ];

  let currentPath = '';
  parts.forEach((part, index) => {
    currentPath += `/${part}`;
    const isLast = index === parts.length - 1;
    items.push({
      '@type': 'ListItem',
      position: index + 2,
      name: isLast ? breadcrumbName(currentPath, route.content?.heading || route.title) : breadcrumbName(currentPath),
      item: buildAbsoluteSiteUrl(currentPath, baseUrl),
    });
  });

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items,
  };
}

function structuredDataForRoute(route, baseUrl = SITE_BASE_URL) {
  const canonical = buildAbsoluteSiteUrl(route.path, baseUrl);
  const isArticle = route.pageType === 'article';
  const primary = {
    '@context': 'https://schema.org',
    '@type': isArticle ? 'Article' : 'WebPage',
    headline: route.content?.heading || route.title,
    name: route.title,
    description: route.description,
    url: canonical,
    mainEntityOfPage: canonical,
    publisher: {
      '@type': 'Organization',
      name: 'BotSpot',
      url: baseUrl,
    },
  };

  if (isArticle && route.lastmod) {
    primary.datePublished = route.lastmod;
    primary.dateModified = route.lastmod;
  }
  if (Array.isArray(route.content?.sources) && route.content.sources.length > 0) {
    primary.citation = route.content.sources.map((source) => absoluteUrl(source.url, baseUrl));
  }

  const graph = [primary];

  if (route.path !== '/') {
    graph.push(buildBreadcrumbs(route, baseUrl));
  }

  if (Array.isArray(route.content?.faq) && route.content.faq.length > 0) {
    graph.push({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: route.content.faq.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    });
  }

  return graph;
}

module.exports = {
  buildBreadcrumbs,
  structuredDataForRoute,
};
